import CopyToClipboard from 'react-copy-to-clipboard';
import { HiLink } from 'react-icons/hi2';
import { RiLinkedinFill, RiTwitterLine, RiWhatsappLine } from 'react-icons/ri';
import { LinkedinShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Secondary } from 'stories/Button.stories';

const ShareButtons = ({ grayout = false }) => {
  const URL = window.location.href;
  const notify = () => {
    toast('Link copied!', {
      position: toast.POSITION.BOTTOM_RIGHT,
      autoClose: 1000,
      className: 'text-red',
      bodyClassName: 'bg-whit p-2 rounded-full',
      // progressClassName: 'hidden',
    });
  };

  const customStyle = grayout ? '' : 'rounded-full shadow-md';

  return (
    <>
      <div>
        <div className="flex gap-x-6 py-2">
          {/* <LinkedinShareButton url={URL}>
            <RiLinkedinFill className="h-[2.5rem] w-[2.5rem] p-2.5 text-red" />
          </LinkedinShareButton> */}
          <WhatsappShareButton className={customStyle} url={URL}>
            {grayout ? (
              <Secondary size="medium" iconCTA>
                <RiWhatsappLine size={20} />
              </Secondary>
            ) : (
              <RiWhatsappLine className="h-[2.5rem] w-[2.5rem] p-2.5 text-red" />
            )}
          </WhatsappShareButton>
          <CopyToClipboard text={URL} onCopy={() => notify()}>
            {grayout ? (
              <Secondary size="medium" iconCTA>
                <HiLink size={20} />
              </Secondary>
            ) : (
              <HiLink
                className={`h-[2.5rem] w-[2.5rem] cursor-pointer p-2.5 text-red ${customStyle}`}
              />
            )}
          </CopyToClipboard>
          <TwitterShareButton className={customStyle} url={URL}>
            {grayout ? (
              <Secondary size="medium" iconCTA>
                <RiTwitterLine size={20} />
              </Secondary>
            ) : (
              <RiTwitterLine className="h-[2.5rem] w-[2.5rem] p-2.5 text-red" />
            )}
          </TwitterShareButton>
        </div>
        <ToastContainer />
      </div>
    </>
  );
};

export default ShareButtons;
